import { useNavigate } from "react-router-dom";
import { useState,useRef,useEffect } from 'react';
import { io } from "socket.io-client";
import style from './chat.module.css';
import Popup from '../popup/popup';

function Chat({login , setLogin,user, setUser,token,removeToken,saveToken,chats,setChats,activeChatId, setActiveChatId}) {
    
     useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://widget.cloudpayments.ru/bundles/cloudpayments.js";
        script.async = true;

        document.body.appendChild(script);
        return () => {
        document.body.removeChild(script);
        };
    }, []);
    
    function pay(mail,id) {

        if (!window.cp) {
            return;
        }
        changePopup(0);
        var widget = new window.cp.CloudPayments({
            language: "ru-RU"
        }) 
        var receipt = {
                "Items": [//товарные позиции
                    {
                        "label": "Получение доступа к im-gpt", //наименование товара
                        "price": '1', //цена
                        "quantity": 1.00, //количество
                        "amount": '1', //сумма
                        "vat": 0, //ставка НДС
                        "method": 0, // тег-1214 признак способа расчета - признак способа расчета
                        "object": 0, // тег-1212 признак предмета расчета - признак предмета товара, работы, услуги, платежа, выплаты, иного предмета расчета
                        "measurementUnit": "шт" //единица измерения
                    }, 
                ],
                "calculationPlace": "www.im-gpt.ru", //место осуществления расчёта, по умолчанию берется значение из кассы
                "email": mail, //e-mail покупателя, если нужно отправить письмо с чеком
                "isBso": false, //чек является бланком строгой отчётности
                "AgentSign": null, //признак агента, тег ОФД 1057
                "amounts":
                {
                    "electronic": '1', // Сумма оплаты электронными деньгами
                    "advancePayment": 0.00, // Сумма из предоплаты (зачетом аванса) (2 знака после точки)
                    "credit": 0.00, // Сумма постоплатой(в кредит) (2 знака после точки)
                    "provision": 0.00 // Сумма оплаты встречным предоставлением (сертификаты, др. мат.ценности) (2 знака после точки)
                }
            }
        
            const tok_prod = 'pk_2e6693b7db8babaa844017a974f80';
            widget.pay('charge', // или 'charge'
                { //options
                    publicId: tok_prod, //id из личного кабинета
                    description: 'Получение доступа к im-gpt', //назначение
                    amount: 1, //сумма
                    currency: 'RUB', //валюта
                    accountId: mail, //идентификатор плательщика (необязательно)
                    invoiceId: id, //номер заказа  (необязательно)
                    skin: "modern", //дизайн виджета (необязательно)
                    autoClose: 3, //время в секундах до авто-закрытия виджета (необязательный)
                    tokenize: true,
                    data: {
                        "CloudPayments": {
                                "CustomerReceipt": receipt //онлайн-чек
                            }
                                                
                    },
                    configuration: {
                        common: {
                            successRedirectUrl: "https://im-gpt.ru/chat", // адреса для перенаправления 
                            failRedirectUrl: "https://im-gpt.ru/chat"        // при оплате по Tinkoff Pay
                        }
                    },
                },
            {
                onSuccess: function (options) { // success
                    //действие при успешной оплате
                },
                onFail: function (reason, options) { // fail
                    //действие при неуспешной оплате
                },
                onComplete: function (paymentResult, options) { //Вызывается как только виджет получает от api.cloudpayments ответ с результатом транзакции.
                    //например вызов вашей аналитики
                }
            }
        )
    }
    function openPay(mail,id,sumz) {
   
        const sum = parseInt(String(sumz || "17").replace(/\s/g, ""), 10);
        if (!window.cp) {
            return;
        }
        changePopup(0);
        var widget = new window.cp.CloudPayments({
            language: "ru-RU"
        })
        var receipt = {
                "Items": [//товарные позиции
                    {
                        "label": "Пополнение токенов на im-gpt", //наименование товара
                        "price": ''+sum, //цена
                        "quantity": 1.00, //количество
                        "amount": '1', //сумма
                        "vat": 0, //ставка НДС
                        "method": 0, // тег-1214 признак способа расчета - признак способа расчета
                        "object": 0, // тег-1212 признак предмета расчета - признак предмета товара, работы, услуги, платежа, выплаты, иного предмета расчета
                        "measurementUnit": "шт" //единица измерения
                    }, 
                ],
                "calculationPlace": "www.im-gpt.ru", //место осуществления расчёта, по умолчанию берется значение из кассы
                "email": mail, //e-mail покупателя, если нужно отправить письмо с чеком
                "isBso": false, //чек является бланком строгой отчётности
                "AgentSign": null, //признак агента, тег ОФД 1057
                "amounts":
                {
                    "electronic": ''+sum, // Сумма оплаты электронными деньгами
                    "advancePayment": 0.00, // Сумма из предоплаты (зачетом аванса) (2 знака после точки)
                    "credit": 0.00, // Сумма постоплатой(в кредит) (2 знака после точки)
                    "provision": 0.00 // Сумма оплаты встречным предоставлением (сертификаты, др. мат.ценности) (2 знака после точки)
                }
            }
            const tok_prod = 'pk_2e6693b7db8babaa844017a974f80';
            widget.pay('charge', // или 'charge'
                { //options
                    publicId: tok_prod, //id из личного кабинета
                    description: 'Пополнение токенов на im-gpt', //назначение
                    amount: sum, //сумма
                    currency: 'RUB', //валюта
                    accountId: mail, //идентификатор плательщика (необязательно)
                    invoiceId: id, //номер заказа  (необязательно)
                    skin: "modern", //дизайн виджета (необязательно)
                    autoClose: 3, //время в секундах до авто-закрытия виджета (необязательный)
                    data: {
                        "CloudPayments": {
                                "CustomerReceipt": receipt //онлайн-чек
                            }
                                                
                    },
                    configuration: {
                        common: {
                            successRedirectUrl: "https://im-gpt.ru/chat", // адреса для перенаправления 
                            failRedirectUrl: "https://im-gpt.ru/chat"        // при оплате по Tinkoff Pay
                        }
                    },
                },
            {
                onSuccess: function (options) { // success
                    //действие при успешной оплате
                },
                onFail: function (reason, options) { // fail
                    //действие при неуспешной оплате
                },
                onComplete: function (paymentResult, options) { //Вызывается как только виджет получает от api.cloudpayments ответ с результатом транзакции.
                    //например вызов вашей аналитики
                }
            }
        )
    }
    const navigate = useNavigate();
    const socketRef = useRef(null);
    const hasEmitted = useRef(false);
    const [isTyping, setIsTyping] = useState(false);
    function changePopup(id) {
        setUser(prev => ({
            ...prev,
            popup: id,
        }));
    }
    const params = new URLSearchParams(window.location.search);
    const [text, setText] = useState("");
    const [pendingFiles, setPendingFiles] = useState([]);
  
    const chatsRef = useRef(chats);

    const inputRefs = useRef({}); // храним refs для инпутов

    

    const models = [
        {
            id: "gpt-5-nano",
            title: "IM-GPT",
            version: "PRO",
            desc: "Быстрые ответы на вопросы"
        },
        {
            id: "gpt-4o-mini",
            title: "ChatGPT",
            version: null,
            desc: "GPT с анализом картинок и файлов"
        },
        {
            id: "gpt-image-1.5",
            title: "GPT IMAGE",
            version: null,
            desc: "Генератор изображений ИИ"
        }
    ];
    const MAX_FILES = 3;
    const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20 MB
    const MAX_TOTAL_SIZE = 50 * 1024 * 1024; // 50 MB
    const ALLOWED_TYPES = [
    "image/png",
    "image/jpeg",
    "image/webp",
    "application/pdf",
    "text/plain",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ];

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        if (!selectedFiles.length) return;

        // Ограничение на количество файлов
        if (selectedFiles.length + pendingFiles.length > MAX_FILES) {
            alert(`Можно прикрепить не более ${MAX_FILES} файлов`);
            e.target.value = "";
            return;
        }

        let totalSize = pendingFiles.reduce((acc, f) => acc + f.file.size, 0);

        const preparedFiles = [];

        for (const file of selectedFiles) {
            // Проверка типа файла
            if (!ALLOWED_TYPES.includes(file.type)) {
            alert(`Файл "${file.name}" не поддерживается`);
            continue;
            }

            // Проверка размера одного файла
            if (file.size > MAX_FILE_SIZE) {
            alert(`Файл "${file.name}" слишком большой (макс 20 MB)`);
            continue;
            }

            // Проверка суммарного размера
            if (totalSize + file.size > MAX_TOTAL_SIZE) {
            alert("Суммарный размер файлов не должен превышать 50 MB");
            break;
            }

            preparedFiles.push({
            id: Date.now() + Math.random(),
            file,
            url: file.type.startsWith("image/") ? URL.createObjectURL(file) : null,
            name: file.name,
            type: file.type
            });

            totalSize += file.size;
        }

        setPendingFiles(prev => [...prev, ...preparedFiles]);

        // Сброс input
        e.target.value = "";
        };
    const getFilePreviewNoUrl = (file) => {
        
        if (file.url) return file.url;
        return 'img/image.png';
    };

    const getFilePreview = (file) => {
        if (file.type?.startsWith("image/") && file.data) {
            return file.data;
        }

        return "/img/image.png"; // универсальная иконка
        };


    const activeChat = chats.find(chat => chat.id === activeChatId);

    const activeModel = models.find(
        model => model.id === activeChat?.modelId
    );

    const [editingChatId, setEditingChatId] = useState(null); 
    const [messages, setMessages] = useState([
    ]);

    const textareaRef = useRef(null);
    const fileInputRef = useRef(null);
    const messagesEndRef = useRef(null);
    const chatScrollRef = useRef(null);
    const ActiveChatRef = useRef(activeChatId);
    const loadMessage = useRef(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const toggleMenu = () => setMenuOpen(!menuOpen);
    const toggleRef = useRef(null);
    const tgpop = useRef(null);
    const sendMessage = async () => {
        if (!token || !socketRef.current) {
            if(params.has("login")){
                if(!login) return changePopup(7);
            }
            else if(params.has("register")){
                if(login) return;
                let utm; 
                if(params.get("utm_source")) utm = params.get("utm_source");
                else if(localStorage.getItem("utm_source")) utm = localStorage.getItem("utm_source");
            
                
                if (!utm) return changePopup(5);
                const value = utm.toLowerCase();
                if (value.includes("promo")) return changePopup(6);
                else return changePopup(5);
                

                
            }
            return changePopup(7);
        }
        if(loadMessage.current === true) return;
        if (!text.trim() && pendingFiles.length === 0) return;
        if(user.token <= 0 && user.sub <= 0) return pay(user.email,user.id);
        if(user.token <= 0) return changePopup(2);
        if(isTyping === true) return false;
        if (ActiveChatRef.current === null) {
            const newChatId = await addChat();
            if (!newChatId) return; // ошибка при создании чата
        }
        loadMessage.current = true;
        // Загружаем все файлы на сервер
        const uploadedFiles = await Promise.all(
            pendingFiles.map(async (fileObj) => {
            const file = fileObj.file;
            if (!file) return null;

            const formData = new FormData();
            formData.append("file", file);
              
            try {
                const res = await fetch("https://im-gpt.ru:3000/api/upload", {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
                });

                const data = await res.json();
                if (data.uploaded) {
                return {
                    id: Date.now(),
                    name: file.name,
                    type: file.type,
                    data: data.url, // ссылка на сервер
                };
                } else {
                console.error("Ошибка при загрузке файла:", data.error);
                return null;
                }
            } catch (err) {
                console.error("Ошибка при загрузке файла:", err);
                return null;
            }
            })
        );

        const payload = {
            chatId: ActiveChatRef.current,
            text: text.trim(),
            files: uploadedFiles.filter(f => f !== null),
        };
        
        socketRef.current.emit("sendMessage", payload);
        // Добавляем сообщение в локальный стейт
        setMessages(prev => [
            ...prev,
            {
            id: Date.now(),
            type: "user",
            text: payload.text,
            files: uploadedFiles.filter(f => f !== null),
            }
        ]);
        loadMessage.current = false;
        setIsTyping(true);
        setText("");
        setPendingFiles([]);
    };



  


    useEffect(() => {
        if (isTyping) {
            // Добавляем блок loader в messages
            setMessages(prev => [
            ...prev,
            {
                id: "loader",   // фиксированный id для loader
                type: "assistant",
                loading: true,
                text: "",
                files: []
            }
            ]);
        } else {
            // Убираем loader
            setMessages(prev => prev.filter(msg => msg.id !== "loader"));
        }
    }, [isTyping]);

    useEffect(() => {
        chatsRef.current = chats; // обновляем ref при каждом изменении
    }, [chats]);
    useEffect(() => {
        ActiveChatRef.current = activeChatId; // обновляем ref при каждом изменении
    }, [activeChatId]);
    // Автопрокрутка вниз
    useEffect(() => {
       const container = chatScrollRef.current;
        if (!container || !messagesEndRef.current) return;

        container.scrollTop = container.scrollHeight;
    }, [messages]);

    useEffect(() => {
        const textarea = textareaRef.current;
        if (textarea) {
        textarea.style.height = 'auto'; // сбрасываем высоту
        textarea.style.height = Math.min(textarea.scrollHeight, 20*5) + 'px'; // до 5 строк
        }
    }, [text]);
    useEffect(() => {
         if(params.has("login")){
            if(!login) changePopup(7);
         }
         else if(params.has("register")){
            if(login) return;
            let utm; 
            if(params.get("utm_source")) utm = params.get("utm_source");
            else if(localStorage.getItem("utm_source")) utm = localStorage.getItem("utm_source");
           
            
            if (!utm) return changePopup(5);
             const value = utm.toLowerCase();
             if (value.includes("promo")) changePopup(6);
             else changePopup(5);
             

             
         }
    },[]);
    const addChat = async () => {
    if (user.token <= 0 && user.sub <= 0) {
        return pay(user.email, user.id);
    }

    try {
        const res = await fetch("https://im-gpt.ru:3000/api/addChat", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        const data = await res.json();

        if (res.ok && data.id_chat) {
            const newChat = {
                id: data.id_chat,
                name: "Новый чат",
                modelId: "gpt-5-nano",
            };

            // Обновляем локальный state
            setChats(prev => [newChat, ...prev]);

            // Делаем чат активным
            setActiveChatId(data.id_chat);
            ActiveChatRef.current = data.id_chat; // <- ключ для sendMessage

            return data.id_chat; // возвращаем id чата
        }
    } catch (err) {
        console.error("Ошибка при создании чата:", err);
        return null;
    }
};


    const deleteChat = async (id) => {
        const res = await fetch("https://im-gpt.ru:3000/api/delChat", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ id }),
        });

        const data = await res.json();

        if (res.ok && data.profile === true) {
            const filtered = chats.filter((chat) => chat.id !== id);
            setChats(filtered);
            if (id === activeChatId && filtered.length > 0) {
                setActiveChatId(filtered[0].id);
            }
            else
            {
                setActiveChatId(null);   
            }
        }
    };
    const changeModel = async (id,model) => {
        if(user.token <= 0 && user.sub <= 0) return pay(user.email,user.id);
        const res = await fetch("https://im-gpt.ru:3000/api/changeModel", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ id, model }),
        });

        const data = await res.json();

        if (res.ok && data.profile === true) {
            setChats(prev =>
                prev.map(chat =>
                    chat.id === activeChatId
                        ? { ...chat, modelId: model }
                        : chat
                )
            );
            if (toggleRef.current) {
                toggleRef.current.checked = false;
            }
        }
    };

   // Функция для отправки нового имени на сервер
    const renameChat = async (id, newName,lastname) => {
    if(editingChatId !== id) return;
    try {
        const res = await fetch("https://im-gpt.ru:3000/api/renameChat", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ id, name: newName }),
        });

        const data = await res.json();

        if (res.ok && data.profile === true) {
        } else {
        setChats(prev =>
            prev.map(chat =>
            chat.id === id ? { ...chat, name: lastname } : chat
            )
        );
        }
    } catch (err) {
        setChats(prev =>
        prev.map(chat =>
            chat.id === id ? { ...chat, name: lastname } : chat
        )
        );
    }
    };

    const changeName = (id, newName) => {
    setChats(prev =>
        prev.map(chat => (chat.id === id ? { ...chat, name: newName } : chat))
    );
    };
    const getMimeByUrl = (url) => {
        if (url.endsWith(".jpg") || url.endsWith(".jpeg")) return "image/jpeg";
        if (url.endsWith(".webp")) return "image/webp";
        if (url.endsWith(".png")) return "image/png";
        return "image/*";
    };
    const handleEditClick = (id) => {
        if(user.token <= 0 && user.sub <= 0) return pay(user.email,user.id);
        setEditingChatId(id);
        setTimeout(() => {
        if (inputRefs.current[id]) {
            inputRefs.current[id].focus();
            inputRefs.current[id].select(); // выделяем текст сразу
        }
        }, 0);
    };
    // --- внутри Chat ---
    useEffect(() => {
        if(hasEmitted.current && activeChatId !== null)
        {
            socketRef.current.emit("getMessages",{id: activeChatId});
        }
        else
        {
            setMessages([]);
        }
    },[activeChatId])
    useEffect(() => {
         if(user.token <= 0 && user.sub <= 0) return pay(user.email,user.id);
    },[user.token])
    useEffect(() => {
        if (!token) {
            hasEmitted.current = false;

            if (socketRef.current) {
                socketRef.current.off();
                socketRef.current.disconnect();
                socketRef.current = null;
            }

            return;
        }

        if (socketRef.current) return; // уже подключены
        socketRef.current = io(`https://im-gpt.ru:3000`, {
            reconnection: true,
            reconnectionAttempts: 150,
            reconnectionDelay: 500,
            reconnectionDelayMax: 5000,
            transports: ['websocket', 'polling'],
            maxHttpBufferSize: 50e6,
            auth: {token: token}
        });
        console.log('socket connect');
        hasEmitted.current = true;
        if(ActiveChatRef.current !== null)
        {
            socketRef.current.emit("getMessages",{id: ActiveChatRef.current});
        }
            
        
        
    
        socketRef.current.on("messages", (msgs) => 
        {
            setMessages(msgs);
        });
        socketRef.current.on("updateTokens", (tok) => 
        {
            setUser(prev => ({
                ...prev,
                token: tok.tokens}));
            if(tok.tokens <= 0)
            {
                changePopup(2);
            }
        });
        socketRef.current.on("updatepayinfo", (tok) => 
        {

            setUser(prev => ({
                ...prev,
                token: tok.tokens_new,
                sub: tok.sub,
                nextpay: tok.newtime}));
            window.ym(96157357,'reachGoal','1');
        });
        
        const handleChangeModel = ({ id, model }) => {
            setChats((prevChats) =>
                prevChats.map((chat) =>
                chat.id === id ? { ...chat, modelId: model } : chat
                )
            );
        };
        socketRef.current.on("changeModel", handleChangeModel);
        socketRef.current.on("assistantTyping", (data) => {
            const chatid = data.chatId;
            const chunk = data.chunk;
            setIsTyping(false);
            if(ActiveChatRef.current !== chatid) return false;
             
        setMessages(prev => {
            if (Array.isArray(chunk) && chunk.every(url => typeof url === "string")) {
                // массив URL картинок
                return [
                ...prev,
                {
                    id: Date.now(),
                    type: "assistant",
                    text: "Готовое изображение",
                    files: chunk.map(url => ({ id: Date.now() + Math.random(), data: url, name: "image.png", type: getMimeByUrl(url) }))
                   
                }
                ];
            }

            // потоковый текст
            const last = prev[prev.length - 1];
            if (last?.type === "assistant" && last.streaming) {
                last.text += chunk;
                return [...prev.slice(0, -1), last];
            } else {
                return [...prev, { id: Date.now(), type: "assistant", text: chunk, streaming: true }];
            }
            });



        });


        return () => {
            socketRef.current.off();
            socketRef.current.disconnect();
            socketRef.current = null;
            hasEmitted.current = false;
        };
    }, [token]);

    return (
    <div className={`${style.chat} ${menuOpen ? style.menuOpen : ''}`}>
        <Popup user={user} setUser={setUser} token={token} removeToken={removeToken} saveToken={saveToken} openPay={openPay}/>
        <div className={style.menu}>
            <div className={style.top}>
                <h1 onClick={() => navigate("/")}>I'm GPT</h1>
                <svg
                    viewBox="0 0 11.0605 10.7071"
                    xmlns="http://www.w3.org/2000/svg"
                    width={11.060547}
                    height={10.707108}
                    fill="none"
                    onClick={toggleMenu}
                    >
                    <g>
                        <path
                        d="M5.70703 0.353554L0.707031 5.35355L5.70703 10.3536"
                        stroke="rgb(255,255,255)"
                        strokeWidth={1}
                        />
                        <path
                        d="M10.707 0.353554L5.70703 5.35355L10.707 10.3536"
                        stroke="rgb(255,255,255)"
                        strokeWidth={1}
                        />
                    </g>
                </svg>
            </div>
            {login ? ( 
            <>
            <div className={style.activeuser}>
                <div className={style.addchat} onClick={addChat}>
                    <span>+</span>Новый чат
                </div>
                {chats.length > 0 &&
                <p className={style.mychats}>Ваши чаты</p>}
                <ul className={style.chats}>
                    {chats.map((chat) => (
                        <li
                            key={chat.id}
                            className={chat.id === activeChatId ? style.active : ""}
                            onClick={() => setActiveChatId(chat.id)}
                        >
                            <div className={style.flexli}>
                            <img src='img/chat.png'className={style.chatimg} alt="chat" />
                            <input
                                type="text"
                                ref={(el) => (inputRefs.current[chat.id] = el)}
                                value={chat.name}
                                readOnly={editingChatId !== chat.id}
                                onChange={(e) => changeName(chat.id, e.target.value)} 
                                 onFocus={(e) => {
                                    e.target.dataset.originalName = chat.name;
                                }}
                                onBlur={(e) => 
                                    {

                                        renameChat(chat.id, e.target.value, e.target.dataset.originalName);
                                        setEditingChatId(null)
                                    }}
                                onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    renameChat(chat.id, e.target.value, e.target.dataset.originalName);
                                    setEditingChatId(null);
                                    e.preventDefault();
                                }
                                }}
                                className={`${editingChatId === chat.id ? style.editing : style.readonly}`}
                            />
                            </div>
                            <div className={style.flexri}>
                            <img
                                src='img/edit.png'
                                className={style.editimg}
                                alt="edit"
                                onClick={() => handleEditClick(chat.id)}
                            />
                            <img
                                src='img/delite.png'
                                className={style.deliteimg}
                                alt="delete"
                                onClick={() => deleteChat(chat.id)}
                            />
                            </div>
                        </li>
                        ))}
                </ul>
            </div>
            <div className={style.profile}>
                
                <input type="checkbox" id="tgpops" className={style.togglepop} ref={tgpop}/>
                
                <label htmlFor="tgpops" className={style.headerselect}>
                    <div className={style.imageuser} style={{backgroundImage: `url(${user.pic || 'img/nopic.png'})`}}>
                    </div>
                    <p>{user.name || user.email}</p>
                </label>
                <ul className={style.popupsettings}>
                        <li onClick={() => changePopup(1)}>
                            <img src='img/profile.png' alt='profile'/>
                            <p>Мой профиль</p>
                        </li>
                        <li onClick={() => changePopup(2)}>
                            <img src='img/setting.png' alt='settings'/>
                            <p>Настройки</p>
                        </li>
                        <li onClick={() => changePopup(3)}>
                            <img src='img/support.png' alt='support'/>
                            <p>Поддержка</p>
                        </li>
                        <li onClick={() => changePopup(4)}>
                            <img src='img/logout.png' alt='logout'/>
                            <p>Выйти</p>
                        </li>
                        <li onClick={() => {
                                if (tgpop.current) {
                                    tgpop.current.checked = false;
                                }
                            }}>
                            <img src='img/close.png' alt='exit'/>
                            <p>Закрыть</p>
                        </li>
                </ul>
                
            </div>
            </>
            ) : (
                <div className={style.noauth}>
                    <h4>Войдите в аккаунт, чтобы получить больше возможностей</h4>
                    <button className={style.loginbtn} onClick={() => changePopup(7)}>Войти</button>
                </div>
            )
        }


        </div>
        <div className={style.chatik}>
            <div className={style.headchat}>
                <div className={style.backmenu} onClick={toggleMenu}>
                    <svg
                        viewBox="0 0 11.0605 10.7071"
                        xmlns="http://www.w3.org/2000/svg"
                        width={11.060547}
                        height={10.707108}
                        style={{ transform: 'rotate(180deg)' }}
                        fill="none"
                        
                        >
                        <g>
                            <path
                            d="M5.70703 0.353554L0.707031 5.35355L5.70703 10.3536"
                            stroke="rgb(255,255,255)"
                            strokeWidth={1}
                            />
                            <path
                            d="M10.707 0.353554L5.70703 5.35355L10.707 10.3536"
                            stroke="rgb(255,255,255)"
                            strokeWidth={1}
                            />
                        </g>
                    </svg>
                </div>
                {login ? ( 
                (activeChatId !== null &&
                (<div className={style.selectgpt}>
                    <input type="checkbox" id="toggle" className={style.toggle} ref={toggleRef}/>

                    <label htmlFor="toggle" className={style.headerselect}>
                        <h3>
                            {activeModel?.title}
                            {activeModel?.version && <span> {activeModel?.version}</span>}
                        </h3>
                        <img src='img/select.png' alt="select" />
                    </label>

                    
                    <ul className={style.popupselect}>
                        {models.map(model => (
                            <li
                                key={model.id}
                                className={activeModel?.id === model.id ? style.active : ""}
                                onClick={() => {
                                    changeModel(activeChatId, model.id);
                                }}
                            >
                                <h3>
                                    {model.title}
                                    {model.version && <span> {model.version}</span>}
                                </h3>
                                <p>{model.desc}</p>
                            </li>
                        ))}
                    </ul>
                </div>
                ))
                ) : (
                    <button className={style.loginbtn + ' ' + style.hidebtn} onClick={() => changePopup(7)}>Войти</button>
                )
                }
            </div>
            <div className={style.chatgpt}>
                <div className={style.scroll}  ref={chatScrollRef}>
                {messages.length === 0  || !login ? (
                    <div className={style.noMessages}>
                        <h3>Привет,</h3>
                        <h4>Чем могу помочь сегодня?</h4>
                    </div>
                 ) : (
                    <div className={style.messages}>
                         {messages.flatMap(msg => {
                        const blocks = [];
                       
                        // текст + код в одном блоке
                        if (msg.text || msg.loading) {
                            blocks.push(
                            <div
                                key={msg.id + "-text"}
                                className={msg.type === "user" ? style.usermess : style.iomess}
                            >
                                 {msg.loading && (
                                    <div className={style.loader}>
                                    </div>
                                )}
                                {msg.text.split(/(```[\s\S]*?```)/g).map((part, i) => {
                                if (part.startsWith("```") && part.endsWith("```")) {
                                    return (
                                    <pre key={i} className={style.codeBlock}>
                                        {part.slice(3, -3)}
                                    </pre>
                                    );
                                } else {
                                    return <span key={i}>{part}</span>;
                                }
                                })}
                            </div>
                            );
                        }

                        // файлы отдельным блоком
                        if (msg.files?.length) {
                            msg.files.forEach(file => {
                            blocks.push(
                                <div
                                key={file.id}
                                className={msg.type === "user" ? style.usermess : style.iomess}
                                >
                                <div
                                    className={style.file}
                                   
                                    title={file.name}
                                >
                                     <img src={`${getFilePreview(file)}`} alt={file.name}/>
                                </div>
                                </div>
                            );
                            });
                        }

                        return blocks;
                        })}
                        <div ref={messagesEndRef} />
                    </div>
                    )}
                </div>
                <div className={style.inputblock}>
                    <div className={style.filelist}>
                        {pendingFiles.map(file => (
                            <div
                                key={file.id}
                                className={style.file}
                                style={{ backgroundImage: `url(${getFilePreviewNoUrl(file)})` }}
                                title={file.name}
                            >

                                {/* кнопка удаления */}
                                <img
                                    src='img/dels.png'// твоя иконка удаления
                                    alt="delete"
                                    className={style.dels}
                                    onClick={() => {
                                        setPendingFiles(prev =>
                                            prev.filter(f => f.id !== file.id)
                                        );
                                    }}
                                />
                            </div>
                        ))}
                    </div>

                    <textarea
                        ref={textareaRef}
                        placeholder="Задай свой вопрос..."
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && (e.preventDefault(), sendMessage())}
                    />
                    <div className={style.flexbtch}>
                        <div className={style.fllebtch}>
                            <img src='img/addi.png' alt='add' onClick={() => fileInputRef.current.click()}/>
                            <p>I'm GPT-5</p>
                            <input
                                type="file"
                                ref={fileInputRef}
                                hidden
                                multiple
                                accept="
                                    image/png,
                                    image/jpeg,
                                    image/webp,
                                    application/pdf,
                                    text/plain,
                                    application/msword,
                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document
                                "
                                onChange={handleFileChange}
                            />

                        </div>
                        <div className={style.send} onClick={sendMessage}>
                            <img src='img/send.png' alt='send'/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Chat;
